<template>
  <Preloader absolute/>
</template>


<script>
import { mapActions } from 'vuex';
import Preloader from '@/components/game/Preloader';

export default {
  name: 'Game_LogoutView',

  components: {
    Preloader,
  },

  methods: {
    ...mapActions([
      'logout',
    ]),
  },

  created() {
    this.logout();
  },
};
</script>
